import SEOArticlePage from "@/components/feature/SEOArticlePage";
import { articleContents } from "@/mocks/seo-article-content";

export default function Top10Templates() {
  return <SEOArticlePage article={articleContents["top-10-templates"]} />;
}